import { Component, OnInit } from '@angular/core';
import {SingleRatingPageService} from '../../../services/single-rating-page.service';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {

  public editRatingButtonName = 'Редактировать рейтинг';
  public backLabel = 'Назад';
  private _detailsId: string | number;
  constructor(
    private singleRatingPageService: SingleRatingPageService,
  ) { }

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    this._detailsId = urlParams.get('detailsId');
  }

  certainRatingTitle(): string {
    return this.singleRatingPageService.ratingTitle;
  }

  editRatingButtonIsAvailable(): boolean {
    return this.singleRatingPageService.isStaff;
  }

  backClickHandler() {
    window.history.back();
  }

  editRatingRedirector() {
    window.open(`/rating-editor?edit=true&ratingId=${this._detailsId}`, '_self');
  }

}
